
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><g clip-path='url(#clip0_17:17885)'><path d='M16.0001 9.00001V14H18.0001V8.00001C18.0001 6.90001 17.1001 6.00001 16.0001 6.00001H10.0001V8.00001H15.0001C15.5501 8.00001 16.0001 8.45001 16.0001 9.00001ZM19.0001 16H9.00009C8.45009 16 8.00009 15.55 8.00009 15V5.00001C8.00009 4.45001 7.55009 4.00001 7.00009 4.00001C6.45009 4.00001 6.00009 4.45001 6.00009 5.00001V6.00001H5.00009C4.45009 6.00001 4.00009 6.45001 4.00009 7.00001C4.00009 7.55001 4.45009 8.00001 5.00009 8.00001H6.00009V16C6.00009 17.1 6.90009 18 8.00009 18H16.0001V19C16.0001 19.55 16.4501 20 17.0001 20C17.5501 20 18.0001 19.55 18.0001 19V18H19.0001C19.5501 18 20.0001 17.55 20.0001 17C20.0001 16.45 19.5501 16 19.0001 16ZM17.6601 1.40001C15.9901 0.51001 13.8301 -0.10999 11.3901 0.0400097L15.2001 3.85001L16.5301 2.52001C19.6201 3.98001 21.8701 6.89001 22.4201 10.38C22.4801 10.79 22.8601 11.07 23.2801 11C23.6901 10.94 23.9701 10.55 23.9001 10.14C23.3001 6.34001 20.9401 3.14001 17.6601 1.40001ZM7.47009 21.49C4.38009 20.03 2.13009 17.12 1.58009 13.63C1.52009 13.22 1.14009 12.94 0.720087 13.01C0.310087 13.07 0.0300865 13.46 0.100087 13.87C0.700087 17.68 3.06009 20.88 6.34009 22.62C8.01009 23.51 10.1701 24.13 12.6101 23.98L8.80009 20.16L7.47009 21.49Z' fill='#323232'/></g><defs><clipPath id='clip0_17:17885'><rect width='24' height='24' fill='white'/></clipPath></defs></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-crop-rotate`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconCropRotate

    ```js
    <b-new-b-icon-crop-rotate />
    ```
</docs>


